export default {

    // Cor de background da tela
    backgroundColor: '#e9e9e7',

    // Cor de fonte de texto que fica dentro do tela, sem nenhum elemento entre ele e o background.
    fontColorOnBackground: "#000000",

    // Cor de background do Card
    cardBackgroundColor: '#00561f',
    // Cor de background de um botão que fica dentro de um card
    cardButtonBackground: '#ffffff',
    // Cor da fonte que fica dentro de um botão de card
    cardButtonFontColor: '#000000',

    // Cor do Activity Indicator
    spinnerColor: '#0b8036',
    // Cor do texto que fica junto do Activity Indicator
    spinnerNoBackgroundTextColor: '#000000',

    tabBarNavigationBackground: '#0b8036',

    // Cor de background da Nav Bar
    navBarColor: '#e8e8e6',
    // Cor do texto que fica na Nav Bar
    navBarTitleColor: '#0b7f36',
    // Cor do ícone que fica na Nav Bar
    navBarIconColor: '#0b7f36',

    tabIconDefault: '#CCCCCC',
    tabIconSelected: '#2F95DC',
    tabBar: '#f18022',

    // Quiz
    quizSelectionBorder: '#0b8036',
    quizCorrectResult: '#0b8036',
    quizIncorrectResult: '#ff0000',

    // Cor de baixo da barra de progresso
    progressBarBackground: '#002c10',
    // Cor da frente da barra de progresso
    progressBarForeground: '#f9cd16',

    errorBackground: '#FF0000',
    errorText: '#FFFFFF',

    warningBackground: '#EAEB5E',
    warningText: '#666804',

    /* Cores para Input */
    // Cor de font de input
    inputFontColor: '#000000',

    // Cor de font de placeholder
    inputPlaceholderFontColor: '#535353',

    // Cor de linha para input
    inputLineColor: 	'#000000',

    // Cor do bullet
    inputBulletPoint: 	'#0b8036',

    // Cor do botão
    buttonColor: 		'#0b8036',

    drawerBackground: 	'#CD9C47',
    drawerLineColor: 	'#FFFFFF',

    // Cor da borda do avatar
    avatarBorder: 		'#0E908D',

    // Cor da estrela preenchida
    starFull: 			'#FFCD01',

    // Cor da estrela não preenchida
    starEmpty: 			'#B1B1B1',
};
